/* global define */

define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'moment',
  'es6!launcher/actions/AnalyticsActions',
], (Util, Immutable, _, moment, Actions) => {
  const initialState = Immutable.Map({
    activeForm: null,
    chartData: null,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_FORM] = (state, action) => {
    const { form } = action.data;

    return state.merge(Immutable.Map({
      activeForm: form,
      chartData: form.getIn(['analytics', 'chartData']),
    }));
  };

  actionHandlers[Actions.UPDATE_SETTING] = (state, action) => {
    const settingName = action.setting;
    const settingValue = action.value;

    if (!settingName) return state;
    return state.setIn([settingName], settingValue);
  };

  return Util.createReducer(initialState, actionHandlers);
});

